import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { MassDeleteCustomerSummary } from '@usf/ngrx-list';

@Component({
  selector: 'app-delete-list-summary-modal',
  templateUrl: './delete-list-summary-modal.component.html',
  styleUrls: ['./delete-list-summary-modal.component.scss'],
})
export class DeleteListSummaryModalComponent {
  @Input() title: string;
  @Input()
  customerList: MassDeleteCustomerSummary[];
  @Input() platform: PlatformEnum;
  @Input() isConfirmation: boolean;
  readonly platformRef = PlatformEnum;

  constructor(private modalController: ModalController) {}

  cancel() {
    this.modalController.dismiss();
  }

  delete() {
    this.modalController.dismiss(true);
  }
}
